import React, { useState } from 'react';

import { useSelector } from 'react-redux';
import { BrowserView, MobileView } from 'react-device-detect';
import { GoInfo } from '@react-icons/all-files/go/GoInfo';
import { StyledHeader, StyledInfoContainer, StyledLogoContainer } from './styled/StyledHeader';
import { Toolbar } from './Toolbar/Toolbar';
import { Logo } from './Logo';
import { LittleLogo } from './LittleLogo';
import InfoModal from './InfoModal';
import { isMobileDevice } from '../../../util/deviceDetection';

export default ({ fetchComplete }) => {
  const config = useSelector((state) => state.config);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const { APPLICATION_ASSETS } = config;
  const hideInfo = APPLICATION_ASSETS?.info === 'hide';

  const showToolbar = config.WITH_TOOLBAR || config.FEATURES?.toolbar === true;

  return (
    <StyledHeader>
      <BrowserView>
        <StyledLogoContainer $viewerMode>
          <Logo />
        </StyledLogoContainer>
      </BrowserView>
      <MobileView>
        <LittleLogo />
      </MobileView>
      {!isMobileDevice() && (hideInfo
        ? <StyledInfoContainer />
        : (
          <StyledInfoContainer>
            <GoInfo onClick={() => setShowInfoModal(!showInfoModal)} />
            <InfoModal show={showInfoModal} onClose={() => setShowInfoModal(!showInfoModal)} />
          </StyledInfoContainer>
        ))}
      {showToolbar && <Toolbar fetchComplete={fetchComplete} />}
    </StyledHeader>
  );
};
